import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MetaData from "../../../components/MetaData";
import { Grid, Form, Button, Message, Icon, Input } from "semantic-ui-react";
import Loader from "../../../components/Loader";
import polyglot from "../../../i18n";
import * as authReducer from "../../Auth/auth.reducer";
import "./changePassword.css";

class ChangePassword extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      errorFlag: false,
      errorMessage: "",
      status: null,
      hidden: true,
      changePasswordForm: {
        password: "",
        confirmPassword: "",
      },
    };
  }

  componentDidMount() {
    this.setState({
      ...this.state,
      changePasswordForm: {
        password: "",
        confirmPassword: "",
      },
    });
  }

  resetPassword = async (e) => {
    e.preventDefault;
    console.log("Resetting password");
    this.setState({ loading: true });
    let data = {
      password: this.state.changePasswordForm.password,
      confirmPassword: this.state.changePasswordForm.confirmPassword,
    };
    if (!data.password || !data.confirmPassword) {
      this.setState({
        errorMessage: "Please fill in all fields.",
        errorFlag: true,
        loading: false,
      });
      return;
    }

    if (data.password !== data.confirmPassword) {
      this.setState({
        errorMessage: "Passwords do not match.",
        errorFlag: true,
        loading: false,
      });
      return;
    }

    // Regular expression to validate password. The password must be more than 6 characters long, contain at least one uppercase letter, one number, one special character and shouldn't contain any spaces.
    const passwordRegx = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})(?!.*\\s)"
    );

    if (!passwordRegx.test(data.password.trim())) {
      this.setState({
        errorMessage:
          "Password must be more than 6 characters long, contain at least one uppercase letter, one number, one special character and shouldn't contain any spaces",
        errorFlag: true,
        loading: false,
      });
      return;
    }

    const response = await this.props.actionChangePassword(data);

    const { status } = response;

    this.setState({
      loading: false,
      status: status,
      errorMessage:
        status !== 200 ? "An error occurred while changing your password." : "",
      errorFlag: false,
    });
  };

  goToProfile = (e) => {
    e.preventDefault();
    this.props.history.push("/profile");
  };

  showPassword = () => {
    this.setState({ hidden: !this.state.hidden });
  };

  render() {
    let loader = "";
    // const { status } = this.props.response;
    const { errorFlag, status } = this.state;
    const comparePassword = (val) => {
      return this.state.changePasswordForm.password !== val;
    };
    const longEnough = (val) => {
      const passwordRegx = new RegExp(
        "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})"
      );
      if (!passwordRegx.test(val)) {
        return true;
      }
      return false;
    };

    if (this.state.loading) {
      loader = <Loader text="Loading, please wait" />;
    }

    let formCode = (
      <div className="ui">
        <MetaData title="Change password" />
        <p className="login-title"> {polyglot.t("changePassword.title")}</p>
        <Form
          error={errorFlag}
          className="ui form"
          model="form.changePasswordForm"
        >
          <Form.Field required>
            <label>{polyglot.t("changePassword.password")}</label>
            <h6 className="reset-password-note">(Min 6 characters)</h6>
            <Grid>
              <Grid.Column width={14}>
                <Input
                  type={this.state.hidden ? "password" : "text"}
                  placeholder="Password"
                  value={this.state.changePasswordForm.password}
                  onChange={(e) =>
                    this.setState({
                      changePasswordForm: {
                        ...this.state.changePasswordForm,
                        password: e.target.value,
                      },
                    })
                  }
                />
              </Grid.Column>
              <Grid.Column
                width={2}
                style={{ marginLeft: "-30px", marginTop: "1px" }}
              >
                <Button basic icon onClick={this.showPassword} type="button">
                  {this.state.hidden ? (
                    <Icon name="eye" />
                  ) : (
                    <Icon name="eye slash" />
                  )}
                </Button>
              </Grid.Column>
            </Grid>
            <Grid.Column width={16} mobile={16} computer={16}>
              <div style={{ fontSize: "13px" }}>
                Tips on Strong Passwords Using a strong password helps protect
                your data. Try creating a password that you will remember but
                will be hard for others to guess by incorporating a mix of upper
                and lower case letters and special characters."
              </div>
            </Grid.Column>
          </Form.Field>
          <Form.Field required>
            <label>{polyglot.t("changePassword.confirmPassword")}</label>
            <Input
              type={this.state.hidden ? "password" : "text"}
              placeholder="Confirm password"
              value={this.state.changePasswordForm.confirmPassword}
              onChange={(e) =>
                this.setState({
                  changePasswordForm: {
                    ...this.state.changePasswordForm,
                    confirmPassword: e.target.value,
                  },
                })
              }
            />
          </Form.Field>
        </Form>
      </div>
    );

    return (
      <React.Fragment>
        <MetaData title="Change Password" />
        <Grid className="change-password-box">
          <Grid.Row>
            <div className="ui centered container change-password">
              {loader}
              <div className="change-password-container">
                {this.state.status !== 200 && formCode}
                {this.state.status === 200 && (
                  <Message
                    success={true}
                    content="Your password has been changed successfully."
                  />
                )}
                {this.state.errorMessage !== "" && (
                  <div style={{ padding: "1rem 0" }}>
                    <Message error={true} content={this.state.errorMessage} />
                  </div>
                )}
                <div
                  className="home-page-link"
                  style={{ padding: this.state.errorMessage ? 0 : "1rem 0" }}
                >
                  <Button
                    size="small"
                    secondary
                    type="submit"
                    className="button-float"
                    onClick={this.resetPassword}
                    style={{
                      display: this.state.status === 200 ? "none" : "block",
                    }}
                  >
                    {polyglot.t("changePassword.submit")}
                  </Button>
                  <Button
                    size="small"
                    className="button-float"
                    type="button"
                    onClick={this.goToProfile}
                  >
                    Back to profile
                  </Button>
                </div>
              </div>
            </div>
          </Grid.Row>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    forms: state.forms,
    response: state.auth.response,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authReducer, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ChangePassword)
);
